<template>
  <div class="main">
    <my_menu2 page_name="招聘数据看板" sys_name='招聘' back_type="close" back_icon="md-close"></my_menu2>
    <div style="height:50px"></div>

    <div class="content" v-if="is_show">
      <Spin fix v-if="table_loading"></Spin>

      <div class="query_div">
        <div class="query_tabs_div">
          <Tabs v-model="dep_index" size="small">
            <TabPane :label="tab1_title" name="0"></TabPane>

            <TabPane :label="tab2_title" name="1"></TabPane>
          </Tabs>
          <span class="query_tab_hint" v-if="kuayue_status">数据跨月，本月数据列已隐藏</span>
        </div>

        <div>
          <DatePicker v-model="query_date[0]" format="yyyy/MM/dd" type="date" size="small" placeholder="开始日期"
            placement="bottom-end" style="width: 120px" />
          <span>-</span>
          <DatePicker v-model="query_date[1]" format="yyyy/MM/dd" size="small" type="date" placeholder="结束日期"
            placement="bottom-end" style="width: 120px" />

          <Button @click="date_picker_change" style="font-size: 12px; margin-left: 5px" size="small"
            type="primary">筛选</Button>
        </div>

        <!-- <DatePicker
          format="yyyy/MM/dd"
          v-model="query_date"
          size="small"
          type="daterange"
          placement="bottom-end"
          placeholder="筛选日期"
          style="width: 200px"
          @on-change="date_picker_change"
        /> -->
      </div>

      <div class="table_box">
        <div class="table_line">
          <div class="dep_name">部门</div>

          <span class="table_block">姓名</span>

          <span class="table_block">邀约</span>

          <span class="table_block">面试</span>

          <span class="table_block">通过</span>

          <span class="table_block">入职</span>

          <span class="table_block">离职</span>

          <span class="table_block" v-if="!kuayue_status">本月邀约</span>

          <span class="table_block" v-if="!kuayue_status">本月面试</span>

          <span class="table_block" v-if="!kuayue_status">本月通过</span>

          <span class="table_block" v-if="!kuayue_status">本月入职</span>

          <span class="table_block" v-if="!kuayue_status">本月离职</span>

          <span class="table_block" v-if="!kuayue_status">本月有效入职</span>
        </div>

        <div class="table_box_inner">
          <div v-for="(item, i) in table_data[Number(dep_index)]" :key="i" class="dep_box">
            <div class="dep_name">
              {{ item.name }}
              <div class="export_btn" @click="click_export(item)">
                <Icon type="ios-cloud-download-outline" />导出数据
              </div>
            </div>

            <div>
              <div v-for="(v, k) in item.count_dict" class="block_div" :key="k">
                <span class="table_block">{{ v.name }}</span>

                <span class="table_block2" @click="click_count('yaoyue', v, item.dep_id, v.yaoyue_list, '邀约')">{{
                  v.yaoyue_list.length }}</span>

                <span class="table_block2" @click="click_count('mianshi', v, item.dep_id, v.mianshi_list, '面试')">{{
                  v.mianshi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(v.mianshi_list.length, v.yaoyue_list.length)
                  }}%</span>
                </span>

                <span class="table_block2" @click="click_count('tongguo', v, item.dep_id, v.tongguo_list, '通过')">{{
                  v.tongguo_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(v.tongguo_list.length, v.mianshi_list.length)
                  }}%</span>
                </span>

                <span class="table_block2" @click="click_count('ruzhi', v, item.dep_id, v.ruzhi_list, '入职')">{{
                  v.ruzhi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.ruzhi_list.length,

                      v.tongguo_list.length
                    )
                  }}%</span>
                </span>

                <span class="table_block2" @click="click_count('lizhi', v, item.dep_id, v.lizhi_list, '离职')">{{
                  v.lizhi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.lizhi_list.length,

                      v.ruzhi_list.length
                    )
                  }}%</span>
                </span>


                <span class="table_block2" v-if="!kuayue_status" @click="
                  click_count(
                    'month_yaoyue',
                    v,
                    item.dep_id,
                    v.month_yaoyue_list,
                    '本月邀约'
                  )
                  ">{{ v.month_yaoyue_list.length }}
                </span>

                <span class="table_block2" v-if="!kuayue_status" @click="
                  click_count(
                    'month_mianshi',
                    v,
                    item.dep_id,
                    v.month_mianshi_list,
                    '本月面试'
                  )
                  ">{{ v.month_mianshi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.month_mianshi_list.length,
                      v.month_yaoyue_list.length
                    )
                  }}%</span>
                </span>

                <span class="table_block2" v-if="!kuayue_status" @click="
                  click_count(
                    'month_tongguo',
                    v,
                    item.dep_id,
                    v.month_tongguo_list,
                    '本月通过'
                  )
                  ">{{ v.month_tongguo_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.month_tongguo_list.length,
                      v.month_mianshi_list.length
                    )
                  }}%</span>
                </span>

                <span class="table_block2_1" v-if="!kuayue_status" @click="
                  click_count(
                    'month_ruzhi',
                    v,
                    item.dep_id,
                    v.month_ruzhi_list,
                    '本月入职'
                  )
                  ">{{ v.month_ruzhi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.month_ruzhi_list.length,
                      v.month_tongguo_list.length
                    )
                  }}%</span>
                </span>

                <span class="table_block2" v-if="!kuayue_status" @click="
                  click_count(
                    'month_lizhi',
                    v,
                    item.dep_id,
                    v.month_lizhi_list,
                    '本月离职'
                  )
                  ">{{ v.month_lizhi_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.month_lizhi_list.length,
                      v.month_ruzhi_list.length
                    )
                  }}%</span>
                </span>

                <span class="table_block2" v-if="!kuayue_status" @click="
                  click_count(
                    'month_valid',
                    v,
                    item.dep_id,
                    v.month_valid_list,
                    '本月有效入职'
                  )
                  ">{{ v.month_valid_list.length }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      v.month_valid_list.length,
                      v.month_ruzhi_list.length
                    )
                  }}%</span>
                </span>
              </div>

              <div class="block_div">
                <span class="table_block">合计：</span>

                <span class="table_block3">{{ item.total_dict.yaoyue_count }}</span>

                <span class="table_block3">{{ item.total_dict.mianshi_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.mianshi_count,
                      item.total_dict.yaoyue_count
                    )
                  }}%</span></span>

                <span class="table_block3">{{ item.total_dict.tongguo_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.tongguo_count,
                      item.total_dict.mianshi_count
                    )
                  }}%</span>
                </span>

                <span class="table_block3">{{ item.total_dict.ruzhi_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.ruzhi_count,
                      item.total_dict.tongguo_count
                    )
                  }}%</span>
                </span>

                <span class="table_block3">{{ item.total_dict.lizhi_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.lizhi_count,
                      item.total_dict.ruzhi_count
                    )
                  }}%</span>
                </span>

                <!-- 月邀约 -->
                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.yaoyue_month_count }}</span>

                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.mianshi_month_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.mianshi_month_count,

                      item.total_dict.yaoyue_month_count
                    )
                  }}%</span>
                </span>

                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.tongguo_month_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.tongguo_month_count,

                      item.total_dict.mianshi_month_count
                    )
                  }}%</span></span>

                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.ruzhi_month_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.ruzhi_month_count,

                      item.total_dict.tongguo_month_count
                    )
                  }}%</span>
                </span>

                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.lizhi_month_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.lizhi_month_count,

                      item.total_dict.ruzhi_month_count
                    )
                  }}%</span>
                </span>

                <span class="table_block3" v-if="!kuayue_status">{{ item.total_dict.valid_ruzhi_month_count }}

                  <span class="count_bfb">{{
                    mianshi_ratio_func(
                      item.total_dict.valid_ruzhi_month_count,

                      item.total_dict.ruzhi_month_count
                    )
                  }}%</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="content">
      <div class="wuquanxian_inner">
        <div>
          <img src="@/assets/image/sys/wuquanxian.png" class="wuquanxian" alt="" />
        </div>

        <div class="wuquanxian_title">没有可用的招聘部门权限！</div>

        <div class="wuquanxian_txt">
          招聘数据权限细粒度更新，如无权限，请联系管理员添加权限
        </div>
      </div>
    </div>

    <Drawer :title="title" :closable="true" v-model="detail_show" width="580">
      <div>
        <Spin fix v-if="detail_loading"></Spin>

        <Table :height="windowHeight - 100" size="small" :columns="columns" :data="detail_data"></Table>
      </div>
    </Drawer>

    <Modal v-model="export_data_show" title="导出数据" :footer-hide="true" width="500">
      <Spin fix v-if="loading_export"></Spin>

      <div class="totp">
        <div class="export_field">动态验证码：</div>
        <div>
          <Input v-model="totp_value" placeholder="大象系统动态码" style="width: 150px" />
        </div>
        <div>
          <Poptip trigger="hover" title="大象系统APP>>我的>>2FA动态码" content="content">
            <span class="totp_hint">找不到动态码?</span>
            <template #content>
              <div class="totp_img_div">
                <img style="width:100%;height:100%" src="@/assets/image/auth/totp.png" alt="">
              </div>
            </template>
          </Poptip>
        </div>
      </div>
      <div class="totp_hint_span">
        <Icon type="ios-alert-outline" color="red" size="16" />为了确保数据安全，导出数据需要验证动态码，动态码可在大象系统APP>我的页面中查看
      </div>
      <div class="export_data_field_button">
        <Button style="font-size: 13px" @click="export_ok" type="primary">
          确认导出
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, download_file } from "@/utils/http.js";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      query_date: [],

      table_loading: false,
      detail_show: false,

      detail_data: [],
      columns: [],

      dep_index: "0",
      detail_loading: false,

      title: "详情",
      is_show: true,
      tab1_title: "",
      tab2_title: "",

      kuayue_status: false,
      export_data_show: false,
      export_item: {},
      totp_value: "",
      loading_export: false
    };
  },

  mounted() {
    var stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
    var stamp2 = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);

    this.query_date = [stamp1, stamp2];

    this.window_change();
    this.get_table_data();
  },

  methods: {

    export_ok() {
      var that = this;
      var item = this.export_item
      var obj = {
        count_dict: item.count_dict,
        dep_name: item.name,
        totp_code: this.totp_value
      };
      this.loading_export = true
      this.$Message.info("正在导出，请稍等一会，如数据过多会较慢");
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/zhaopin/data_detail_export",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.export_url;
            that.$Modal.confirm({
              title: "提示",
              content: "<p>导出完成，是否下载？</p>",
              onOk: () => {
                download_file(url, item.name + "-招聘数据导出.xls");
              },
              onCancel: () => { },
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading_export = false
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    get_month() {
      if (this.query_date[0].getYear() + this.query_date[0].getMonth() == this.query_date[1].getYear() + this.query_date[1].getMonth()) {
        return false;
      } else {
        return true;
      }
    },

    //点击导出
    click_export(item) {
      this.export_item = item
      this.export_data_show = true
    },

    click_count(status, item, dep_id, id_list, title) {
      this.detail_show = true;
      this.title = title + "-详情";

      var that = this;
      this.detail_loading = true;
      var obj = {
        id_list: id_list,
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
        dep_id: dep_id,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/zhaopin/data_detail",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.detail_data = res.data.table_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.detail_loading = false;
        })
        .catch((res) => {
          that.detail_loading = false;

          console.log(res, "请求出错");
        });
    },

    //时间筛选变化
    date_picker_change(e) {
      console.log(e);
      this.table_data = [];
      this.get_table_data();

      //   检测跨月
      var ky = this.get_month();
      console.log(ky);
      this.kuayue_status = ky;
    },

    //获取表格数据
    get_table_data() {
      var that = this;
      this.table_loading = true;
      var obj = {
        start_time: this.query_date[0].getTime() / 1000,
        end_time: this.query_date[1].getTime() / 1000,
      };
      http("post", process.env.VUE_APP_HOST + "/data_panel/zhaopin/data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.data_list;

            that.tab1_title = "招聘部门 (" + String(res.data.data_list[0].length) + ")";
            that.tab2_title = "项目部门 (" + String(res.data.data_list[1].length) + ")";

            var count = 0;
            for (var i = 0; i < that.table_data.length; i++) {
              count += that.table_data[i].length;
            }
            if (count > 0) {
              that.is_show = true;
            } else {
              that.is_show = false;
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          this.table_loading = false;
        })
        .catch((res) => {
          this.table_loading = false;
          console.log(res, "请求出错");
        });
    },

    mianshi_ratio_func(a, b) {
      if (b == 0) {
        return "0.0";
      }

      return ((a / b) * 100).toFixed(1);
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.export_data_field_button {
  display: flex;
  justify-content: end;
  margin-top: 20px;

}


.totp_hint_span {
  font-size: 13px;
  color: #dd0404;
}

.totp_hint {
  font-size: 13px;
  margin-left: 10px;
  color: #ccc;
  cursor: pointer;
}

.totp_hint:hover {
  color: #0466dd
}

.totp_img_div {
  width: 200px;
  height: 400px;
  ;
}

.totp {
  display: flex;
  align-items: center;
}

.query_tab_hint {
  font-size: 12px;
  background: #ffb9b9;
  color: #333;
  padding: 2px 10px;
  border-radius: 3px;
  margin-left: 10px;
}

.query_tabs_div {
  display: flex;
  align-items: center;
}

.export_btn {
  color: #0466dd;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
}

.wuquanxian_title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}

.wuquanxian_txt {
  font-size: 14px;
  color: #ccc;
}

.wuquanxian_inner {
  padding-top: 20px;
  text-align: center;
}

.wuquanxian {
  width: 300px;
  height: 300px;
}

.count_bfb {
  font-weight: 300;
  font-size: 8px;
  color: #bababa;
  background-color: #f3f3f3;
  padding: 1px 3px;
  border-radius: 2px;
}

.table_box_inner {
  overflow: auto;
  height: calc(100vh - 140px);
}

.query_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table_line {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  background-color: #0466dd;
  color: #fff;
  font-size: 13px;
}

.dep_name {
  width: 100px;
  flex-shrink: 0;
}

.block_div {
  display: flex;
  margin-bottom: 3px;
  padding: 3px;
  border-bottom: 1px solid rgb(249, 248, 248);
}

.table_block {
  width: 80px;
  flex-shrink: 0;
}

.table_block2 {
  width: 80px;
  color: #0466dd;
  cursor: pointer;
  flex-shrink: 0;
}

.table_block2_1 {
  width: 80px;
  color: #021fbd;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.table_block3 {
  font-weight: 600;
  width: 80px;
  color: #333;
  cursor: pointer;
  flex-shrink: 0;
}

.dep_box {
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-size: 13px;
  padding: 10px;
  border: 1px solid rgb(241, 241, 241);
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  height: calc(100vh - 120px);
  position: relative;
  overflow: hidden;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  background: #fff;
  height: calc(100vh - 60px);
  margin: 0 10px;
  padding: 0 10px;
  border-radius: 5px;
}

.main {
  background: #f5f7f9;
}
</style>
